<template>
  <div>
    <el-dialog class="dialog-mini" width="90%" title="编辑" :visible.sync="dialogVisible" :close-on-click-modal="false"
               top="44px" @close="handleCancel">
      <div v-if="dialogVisible" class="edit_dialog" style="height: calc(70vh);overflow: auto;" v-loading="isLoading">
        <div class="createPost-container">
          <el-form class="form-container" :model="postObj" :rules="rules" ref="postObj">
            <!--选择模板-->
            <div class="createPost-main-container">
              <div class="flow-form-content">
                <el-card class="box-card" v-if="postObj.frmType == 1">
                  <component ref="frmEditData" v-bind:is="postObj.dbName +'Add'"></component>
                </el-card>
                <template v-else-if="postObj.frmType === 2">
                  <CreatedForm insite="true" ref="frmEditData"
                               v-if="createdFormData.list && createdFormData.list.length > 0" :data="createdFormData"
                               :value="initData" :funModel="funModel" :tableDeleteFun="tableDeleteFun"
                               :errDetailGuidArray="errDetailGuidArray"
                  >
                    <template v-for="(item) in soltNameArray">
                      <slot :name="item" :slot="item"></slot>
                    </template>
                  </CreatedForm>
                </template>
                <form ref="frmEditData" v-else>
                  <p v-html="frmPreview"></p>
                </form>
              </div>
              <div class="flow-form-content" style="height: 300px;" v-if="isFlow">
                <CreatedFlow ref="createdFlow" :form-template="currentForm" :isEdit="true"
                             :isShowContent="isShowContent" :scheme-content="currentScheme.schemeContent"></CreatedFlow>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <div slot="footer">
        <el-button v-for="(item) in attachBtnInternal" size="mini" :key="item.btnName" :type="item.type"
                   :disabled="item.disabled" @click="item.clickFunc()">{{ item.btnName }}
        </el-button>
        <el-divider v-if="attachBtnInternal.length > 0" direction="vertical"></el-divider>
        <el-button size="mini" @click="handleCancel">取消</el-button>
        <template v-if="isFlow">
          <el-button size="mini" type="warning" @click="submitForm(0)"
                     v-if="initData.flowInstanceId ===''">保存草稿
          </el-button>
          <el-button size="mini" type="primary" @click="submitForm(1)"
                     v-if="initData.flowInstanceId ===''">提交流程
          </el-button>

          <el-button size="mini" type="primary" @click="submitForm('1')"
                     v-if="initData.flowInstanceId !==''
                && initData.isFinish === 4
                && initData.activityType=== '3' ">重新提交
          </el-button>
        </template>
        <template v-else>
          <el-button v-if="!attachBtnInternal||attachBtnInternal.length==0" size="mini" type="primary"
                     @click="submitForm(2)">保存
          </el-button>
          <!-- <el-button size="mini" type="primary" @click="submitForm(2)">保存</el-button> -->
        </template>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  formatTime
} from '@/utils/index';
import MDinput from '@/components/MDinput';
import Sticky from '@/components/Sticky'; // 粘性header组件
import * as apiFlowschemes from '@/api/flowschemes';
import * as apiFlowinstances from '@/api/flowinstances';
import * as apiForms from '@/api/forms';
import CreatedForm from '@/components/Formcreated/components/CreatedForm';
import CreatedFlow from '@/components/CreatedFlow';

export default {
  name: 'bizinstance-add',
  components: {
    MDinput,
    Sticky,
    CreatedForm,
    CreatedFlow
  },
  props: {
    tableDeleteFun: {
      type: Function,
      default() {
        return;
      }
    },
    otherSubmitModel: {
      type: Object,
      default() {
        return {};
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    sourceCode: {
      type: String,
      default: ''
    },
    tableClassName: {
      type: String,
      default: ''
    },
    flowdbName: {
      type: String,
      default: ''
    },
    initData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    soltNameArray: {
      type: Array,
      default() {
        return [];
      }
    },
    errDetailGuidArray: {
      type: Array,
      default() {
        return [];
      }
    },
    funModel: {
      type: Object,
      default() {
        return {};
      }
    },
    attachBtn: {
      type: Array,
      default() {
        return [];
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validateRequire = (rule, value, callback) => {
      if (value === '') {
        this.$message({
          message: rule.field + '为必传项',
          type: 'error'
        });
        callback(null);
      } else {
        callback();
      }
    };
    return {
      isFlow: false,
      dialogVisible: false,
      isShowContent: true,
      currentForm: null,
      postObj: {
        id: undefined,
        code: new Date().getTime(),
        dbName: '', // 关联的数据库名
        frmType: 0, // 表单类型 0：默认动态表单，1：用户自定义页面
        description: '',
        customName: '',
        frmData: '',
        schemeId: ''
      },
      loading: false,
      flowschemes: [], // 选择的流程模板列表
      createdFormData: {
        list: [],
        config: {}
      },
      fields: 0, // 表单数据元素个数
      currentSchemeId: '',
      currentSourceId: '',
      currentScheme: {
        schemeContent: ''
      }, // 当前选中的流程模板
      frmPreview: '',
      active: 0,
      rules: {
        schemeNameRule: [{
          validator: validateRequire
        }],
        frmRule: [{
          validator: validateRequire
        }]
      },
      attachBtnInternal: []
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      this.currentSourceId = this.sourceCode;
    },
    currentSourceId() {
      var _this = this;
      var queryObj = { SourceCode: this.sourceCode };
      apiForms.getCreeateFrom(queryObj).then(response => {
        if (response.result.enableFlow) {
          // 启用流程审核
          apiFlowschemes.get({ id: response.result.schemeId }).then(response => {
            _this.currentScheme = response.result;
            _this.postObj.customName = _this.currentScheme.schemeName + formatTime('yyyy-MM-dd hh:mm:ss');
          });
          _this.postObj.schemeId = response.result.schemeId;
          _this.isFlow = true;
        }
        if (response.result.frmType === 1) { // 用户自定义的页面
          _this.postObj.frmType = 1;
          _this.postObj.dbName = response.result.webId;
        } else if (response.result.frmType === 2) {
          _this.postObj.frmType = 2;
          _this.postObj.dbName = '';
          response.result.html = response.result.content; // 暂无用content替代一下html
          //  _this.frmPreview = response.result.content
          _this.createdFormData = JSON.parse(response.result.contentData);
          _this.frmPreview = response.result.html; // 表单预览的数据
          _this.fields = response.result.fields; // 表单属性的个数
        } else {
          _this.postObj.frmType = 0;
          _this.postObj.dbName = '';
          _this.frmPreview = response.result.content;
          _this.frmPreview = response.result.html; // 表单预览的数据
          _this.fields = response.result.fields; // 表单属性的个数
        }
      }).catch(() => {
        // console.log(err)
      });
    },
    attachBtn(val) {
      this.attachBtnInternal = val;
    }
  },
  computed: {
    contentShortLength() {
      return this.postObj.description ? this.postObj.description.length : 0;
    }
  },
  created() {
    // this.currentSourceId = this.sourceCode
    this.attachBtnInternal = this.attachBtn;
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false;
      this.$emit('update:visible', false);
    },
    handleAddFlowInstance() {
      const _this = this;
      _this.postObj.dbName = this.flowdbName;
      apiFlowinstances.add(_this.postObj).then(() => {
        _this.loading = false;
        _this.$notify({
          title: '成功',
          message: '创建成功',
          type: 'success',
          duration: 2000
        });
        this.handleCancel();
        this.$parent.getList();
      });
      _this.loading = false;
    },
    handleEditBizInstance(data) {
      const _this = this;
      this.$parent.getApi().update(data).then(() => {
        _this.loading = false;
        this.$notify({
          title: '成功',
          message: '更新成功',
          type: 'success',
          duration: 2000
        });
        this.handleCancel();
        // this.$parent.RefreshRowData(data)
        this.$parent.getList();
      });
      _this.loading = false;
    },
    submitForm(status) {
      var _this = this;
      if (Object.keys(_this.otherSubmitModel).includes('othersub')) { // 使用该方法时，应该返回一个Promise对象
        _this.otherSubmitModel.othersub().then(res => {
          // console.log(res)
          this.submitExecFun(_this, status);
        }).catch(() => {
          return false;
        });
      } else {
        this.submitExecFun(_this, status);
      }
    },
    submitExecFun(_this, status) {
      _this.$refs.postObj.validate(valid => {
        if (valid) {
          _this.loading = true;
          if (_this.postObj.frmType === 1) { // 使用的是自定义的页面提交
            _this.$refs.frmEditData.getData().then(res => {
              if (status === 1) {
                _this.postObj.frmEditData = JSON.stringify(res);
                _this.handleAddFlowInstance();
              } else {
                _this.handleEditBizInstance(res);
              }
            }).catch(() => {
              _this.loading = false;
            });
            return;
          } else if (_this.postObj.frmType === 0) { // 解析表单中提交的数据
            const frmdata = {};
            for (let i = 0; i < _this.$refs.frmEditData.elements.length; i++) {
              frmdata[_this.$refs.frmEditData[i].name] = _this.$refs.frmEditData[i].value;
            }
            if (status === 1) {
              _this.postObj.frmData = JSON.stringify(frmdata);
              _this.handleAddFlowInstance();
            } else {
              _this.handleEditBizInstance(frmdata);
            }
            return;
          } else {
            _this.$refs.frmEditData.getData().then(res => {
              if (status === 1 || status === '1') {
                _this.postObj.frmData = JSON.stringify(res);
                if (status === '1') {
                  _this.postObj.flowInstanceId = res.flowInstanceId;
                }
                _this.handleAddFlowInstance();
              } else {
                _this.handleEditBizInstance(res);
              }
            }).catch(() => {
              _this.loading = false;
            });
            return;
          }
        } else {
          // console.log('error submit!!')
          return false;
        }
      });
    }
  }
};

</script>

<style rel="stylesheet/scss" lang="scss">
@import 'src/styles/mixin.scss';

iframe {
  border: 0;
}

.createPost-container {
  //margin: 10px;
  padding: 0 10px 0 10px;
  background-color: white;
  min-height: 100%;

  .createPost-main-container {
    max-width: 1000px;
    margin: 0 auto;
    // margin-top: 40px;
  }
}

.steps {
  max-width: 1000px;
  margin: 0 auto;

  .el-step__main {
    margin-left: -21px;
  }
}

.edit-btns {
  padding: 20px;
}

.el-tabs--border-card {
  border: 1px solid #dcdfe6;
  -webkit-box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0.12), 0 0 0px 0 rgba(0, 0, 0, 0.04);
  box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0.12), 0 0 0px 0 rgba(0, 0, 0, 0.04);
}

.el-tabs--border-card.border-b-none {
  border-bottom: 0 !important;
}

.editor {
  padding: 15px;
  border: 1px solid #dcdfe6;
  border-top: 0;
}

.flow-form-content {
  margin-top: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
}
</style>
